import React,{useState,useEffect} from "react";
import { Trans, useTranslation} from 'react-i18next'
import Select from 'react-select'
import ReactModal from 'react-modal';
import CrossIcon from './../../../../images/crossicon.png'
import Cookies from 'universal-cookie';
import {useLocation,useNavigate} from "react-router-dom";
import axios from 'axios' 

function DeleteSettings({toogleOption,toogleTaskbar}){
        const NotificationOptions = [{ value: 'Yes', label: 'Yes' },{ value: 'No', label: 'No' }]
        const [Notifications,setNotifications] = useState()
        const {t, i18n } = useTranslation();
        const [deleteAccPopup,setDeleteAccPopup] = useState(false)
        const [deleteSuccessfulPopUp,setDeleteSuccessfulPopup] = useState(false)
        const [deleteAccInput,setDeleteAccInput] = useState("")
        const [confirmdeleteAcc,setConfirmDeleteAcc] = useState(false)
        const cookies = new Cookies(null ,{ path: '/' });
        const navigate = useNavigate();

        const changeNotificationHandler = value =>{
            setNotifications(value)
        }
 
        const confirmDeleteAcc = (val) =>{
            if(val==="delete my account permanently"){
                setConfirmDeleteAcc(true)
            }
        }

        const handleLogout = () =>{
            cookies.set('token', undefined)
            cookies.set('staysignedin', false)
            navigate("/")
          }

        const colourStyles = {
            control: styles => ({ ...styles,  borderColor: '#636468',
            backgroundColor:'rgba(0,0,0,16%)',
            width: '29.75em',
            height: '3em',
            borderRadius:'8px',
            color:'rgba(255, 255, 255, 1)',
            marginTop:'0.8em'
           }),
            option: (styles, { data, isDisabled, isFocused, isSelected }) => {
              return {
                ...styles,
                backgroundColor:'#18191F' ,
                color:'rgba(255, 255, 255, 1)',
                cursor: isDisabled ? 'not-allowed' : 'default',
                marginTop:'-0.3em',
                marginBottom:'-0.3em'
              };
            },
            input: (styles) => ( {...styles , 
                                    FontFamily:'ClashGrotesk-Variable,sans-serif',
                                    FontSize:'1rem',
                                    FontWeight: 'medium',
                                    LineHeight: '150%',
                                    LetterSpacing: '0%',
                                    color:'rgba(255, 255, 255, 1)'}),
            singleValue : (styles) => ({ ...styles, 
                                            color:'rgba(255, 255, 255, 1)',
                                            FontFamily:'ClashGrotesk-Variable,sans-serif',
                                            FontSize:'1rem',
                                            FontWeight: 'medium',
                                            LineHeight: '150%',
                                            LetterSpacing: '0%'})
          };

        useEffect(()=>{
            toogleOption(6)
        },[])

        const DeleteAccount = () =>{
          axios.delete(
            "https://n3rve.fly.dev/account", 
            {headers:{
              Authorization: "Bearer ".concat(cookies.get("token"))
             }}
            ).then((e)=>{
              console.log(e)
            }).catch((e)=>{
              console.log(e)
            })
        }


        return (
            <div style={{display:'flex',flexDirection:'column',paddingBottom:'2.5em',paddingRight:'2em',borderRadius:'8px',marginLeft:'2.5em',marginTop:'1.5em',width:'93.28%',backgroundImage:' linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
            <div className="MembershipTxt">DELETE ACCOUNT</div>
           

                <div className="UpdateBtn" style={{maxWidth:'10em'}} onClick={()=>setDeleteAccPopup(true)}>
                Delete Account
                <div className="PostLoginBtnOverlay" style={{left:'0em'}}/>
                </div>

                    <ReactModal
                                    overlayClassName="Overlay"
                                 isOpen={deleteAccPopup}
                                 contentLabel="Example Modal"
                                 style={{
                                    content:{
                                    width:'35em',
                                    height:'21.31em',
                                    margin:'auto',
                                    backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    borderRadius:'8px',
                                    border:'0.5px solid rgba(255,255,255,25%)'
                                    }
                                 }}
                                 >
                                    
                                          <div className="popupheaderinfo" style={{fontSize:'1.5em'}}>Confirm Account Deletion</div>
                                          <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>setDeleteAccPopup(false)}/>
                                       

                                    

                                          <span className="SettingPopupH3" style={{width:'85%',marginTop:'2em',marginLeft:'-1.2em'}}>Deleting your account will lose membership perks, products, assets, and releases. This action cannot be undone. </span>
                                          <div className="MfaInputHeader">
                                          To confirm, type “delete my account permanently” below:
                                          </div>

                                    
                                          <input
                                          value={deleteAccInput}
                                          onChange={e => {setDeleteAccInput(e.target.value);confirmDeleteAcc(e.target.value)}} 
                                          className='DeleteAccInput'
                                          type='text'
                                          placeholder="delete my account permanently"
                                          />
                                       

                                          <div style={{display:'flex',flexDirection:'row',marginTop:'2em'}}>
                                             <div className="GoBackBtn" style={{paddingTop:'0.55em',paddingBottom:'0.5em',marginRight:'1em',cursor:'pointer'}} onClick={()=>{setDeleteAccPopup(false)}}>
                                                Cancel
                                             </div>

                                             {
                                                confirmdeleteAcc &&
                                                <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer'}} onClick={()=>{setDeleteAccPopup(false);setDeleteSuccessfulPopup(true);setDeleteAccInput("");DeleteAccount()}}>
                                                      Delete Account
                                                </div>
                                             }

                                             {
                                                !confirmdeleteAcc &&
                                                <div className="IUnderstandBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}} >
                                                      Delete Account
                                                </div>
                                             }
                                             
                                          </div>
                  </ReactModal>

                  <ReactModal
                                 overlayClassName="Overlay"
                                 isOpen={deleteSuccessfulPopUp}
                                 contentLabel="Example Modal"
                                 style={{
                                    content:{
                                    width:'35em',
                                    height:'10.31em',
                                    margin:'auto',
                                    backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    borderRadius:'8px',
                                    border:'0.5px solid rgba(255,255,255,25%)'
                                    }
                                 }}
                                 >
                                    
                                          <div className="popupheaderinfo" style={{fontSize:'1.5em',alignSelf:'center',textAlign:'center'}}>Account Deleted</div>
                                         
                            
                                          <div className="IUnderstandBtn" style={{cursor:'pointer',width:'90%',marginTop:'3em'}} onClick={()=>{setDeleteSuccessfulPopup(false);handleLogout()}}>Continue</div>
                                       
                  </ReactModal>     
            </div>
        )
}

export default DeleteSettings;